module.exports = __webpack_public_path__ + "static/img/smartInterb.81fa885.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/smartInterb.png
// module id = /qdj
// module chunks = 1